import React from "react";
import styled from "styled-components";
import { SheetButton } from "../atoms/Button";
import { Theme } from "../atoms/theme";

interface SheetProps {
  options: { action: () => void; text: string }[];
  badge?: JSX.Element;
}

const OptionsWrapper = styled.div`
  width: 18.75rem;
  padding: 1rem;
  background: ${({ theme }) => theme.colors.neutrals_500};
  box-shadow: ${({ theme }) => theme.shadows.dropshadow_l};
  border-radius: 0.75rem;
`;
export const Sheet = ({ options, badge }: SheetProps) => {
  return (
    <OptionsWrapper>
      {options.map((option, idx) => {
        const isLogout = option.text.toLowerCase().includes("logout");
        const buttonColor = isLogout ? "#dc2626" : Theme.colors.primaries_000;
        const hoverColor = isLogout ? "#b91c1c" : Theme.colors.primaries_000;
        const textColor = isLogout ? "#dc2626" : undefined;

        return badge ? (
          <SheetButton
            color={buttonColor}
            width="100%"
            hoverColor={hoverColor}
            contentColor={textColor}
            badge={badge}
            id={`option_${option.text}_${idx}`}
          />
        ) : (
          <SheetButton
            color={buttonColor}
            width="100%"
            hoverColor={hoverColor}
            contentColor={textColor}
            buttonText={option.text}
            onClick={option.action}
            id={`option_${option.text}_${idx}`}
          />
        );
      })}
    </OptionsWrapper>
  );
};
